import SwapHoriz from '@mui/icons-material/SwapHoriz';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import ReactComponent from '../ReactComponent'; // Ajuste o caminho conforme o seu projeto
import ComposicaoUtil from './ComposicaoUtil';
import ModalConfirmacao from './ModalConfirmacao';

class BotaoAlternarSigla extends ReactComponent {
    open = false;

    setOpen = (valor) => {
        this.open = valor;
    };

    handleConfirmar = () => {
        const { magistrado, novaComposicao, onConfirmar } = this.props;
        const entradaAtual = ComposicaoUtil.getEntradaDominioAtual(magistrado, this.props.dominioStore);
        const proxima = ComposicaoUtil.variantePosterior(entradaAtual, this.props.dominioStore);

        if (onConfirmar) {
            onConfirmar(proxima);
        } else if (novaComposicao) {
            const item = novaComposicao.find((comp) => comp.magistrado.cpf && comp.magistrado.cpf === magistrado.cpf);

            if (item) {
                item.magistrado.sigla = proxima.sigla;
                item.magistrado.siglaAdministrativa = proxima.siglaAdministrativa;
                item.magistrado.converterSigla = proxima.sigla !== proxima.siglaAdministrativa;
            }
        }
        this.setOpen(false);
    };

    constructor(props) {
        super(props);

        makeObservable(this, { render: false, open: observable, setOpen: action, handleConfirmar: action });
    }

    render() {
        const { magistrado, dominioStore, salaSessaoStore, registroVirtualComposicao, exibir } = this.props;

        const permitido = exibir ?? salaSessaoStore?.isProcessoPje(registroVirtualComposicao);

        if (!permitido) {
            return null;
        }

        if (!salaSessaoStore?.isProcessoPje(registroVirtualComposicao)) {
            return null;
        }

        const entradaAtual = ComposicaoUtil.getEntradaDominioAtual(magistrado, dominioStore);
        const proxima = ComposicaoUtil.variantePosterior(entradaAtual, dominioStore);

        if (!proxima) {
            return null;
        }

        const destino =
            proxima.sigla === proxima.siglaAdministrativa
                ? proxima.sigla
                : `${proxima.sigla} (como ${proxima.siglaAdministrativa})`;

        const descreverVariante = (v) =>
            v && v.sigla !== v.siglaAdministrativa
                ? `${v.sigla} (como ${v.siglaAdministrativa})`
                : v?.sigla || magistrado.sigla;

        return (
            <>
                <Tooltip
                    placement="top"
                    title={`Alternar para ${destino}`}
                >
                    <IconButton
                        onClick={() => this.setOpen(true)}
                        size="small"
                        sx={{ padding: '2px', marginLeft: '2px' }}
                    >
                        <SwapHoriz fontSize="small" />
                    </IconButton>
                </Tooltip>

                {this.open ? (
                    <ModalConfirmacao
                        open
                        callbackCancelar={() => this.setOpen(false)}
                        callbackConfirmar={this.handleConfirmar}
                        iconeBotaoConfirmacao={<SwapHoriz />}
                        textoBotaoCancelamento="Cancelar"
                        textoBotaoConfirmacao="Alternar"
                        titulo="Alternar sigla do magistrado"
                    >
                        <Typography>
                            Alternar {magistrado.nome} de <b>{descreverVariante(entradaAtual)}</b> para{' '}
                            <b>{descreverVariante(proxima)}</b>?
                        </Typography>
                    </ModalConfirmacao>
                ) : null}
            </>
        );
    }
}

export default inject('stores')(observer(BotaoAlternarSigla));
